import styled from "styled-components";





export default function Footer() {
 
  const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: right;
  margin-top : 60px;
  margin-bottom : 20px;
  padding-left: 30px;
  padding-right: 30px;
  color: var(--title-text-color);
  font-family: 'Söhne Breit Half';
  @media only screen and (max-width: 900px){    
    justify-content: center;
   
}
    
  
`;
 

    return (
        <FooterContainer>

                      
            <h3>Abstract Labs © 2022</h3>
            
        </FooterContainer>

    );
}
